define('entities/companies/companies',[
  'app',
  'backbone',
  'settings',
  'underscore',
  'jquery'
], function (
  App,
  Backbone,
  Settings,
  _,
  $
) {
  'use strict';

  var Company = Backbone.Model.extend({
    idAttribute: 'secId',

    defaults: function () {
      return {
        secId: null,
        cAccountId: null,
        name: null,
        emailDomain: null,
        vatNumber: null,
        addressL1: null,
        addressL2: null,
        zip: null,
        city: null,
        countryCode: null,
        tel: null,
        logoUid: null,
        webSite: null,
        industry: null,
        employees: null,
        annualRevenue: null,
        totalFunding: null,
        companyPhone: null,
        linkedIn: null,
        foundedYear: null,
        nbrEndUsers: null,
        orderAmount: null
      };
    },

    // Sub-accounts (EndUsers) belonging to this company.
    getEndUsers: function () {
      var defer = $.Deferred();
      $.ajax({
        method: 'GET',
        url: Settings.url('compuzz2', 'companies.json/' + this.get('secId') + '/endusers'),
        success: function (items) {
          defer.resolve(items || []);
        },
        error: function () {
          defer.resolve([]);
        }
      });
      return defer.promise();
    }
  });

  var Companies = Backbone.Collection.extend({
    model: Company,
    url: function () {
      return Settings.url('compuzz2', 'companies.json/all');
    }
  });

  var API = {
    getCompanyModel: function (secId) {
      var company = new Company();
      company.url = Settings.url('compuzz2', 'companies.json/' + secId);
      return company;
    },

    getCompaniesCollection: function () {
      return new Companies();
    }
  };

  App.reqres.setHandler('companies:entity', function (secId) {
    return API.getCompanyModel(secId);
  });

  App.reqres.setHandler('companies:collection', function () {
    return API.getCompaniesCollection();
  });

  App.reqres.setHandler('companies:list-url', function (params) {
    return Settings.url('compuzz2', 'companies.json/all', params);
  });

  App.reqres.setHandler('companies:list-count-url', function (params) {
    return Settings.url('compuzz2', 'companies.json/rowCount', params);
  });

  App.reqres.setHandler('companies:export-url', function (params) {
    return Settings.url('compuzz2', 'companies.json/excel', params);
  });

  // Import (enrich) companies from an Excel file. The backend matches rows on the Uid
  // column and updates only the editable/firmographic fields. Returns {updated, skipped}.
  App.reqres.setHandler('companies:upload-excel', function (fileInfo) {
    var defer = $.Deferred();
    var formData = new FormData();
    formData.append('file', fileInfo.base64Value);
    formData.append('filename', fileInfo.fileName);
    $.ajax({
      type: 'POST',
      url: Settings.url('compuzz2', 'companies.json/excel'),
      data: formData,
      processData: false,
      contentType: false,
      success: function (resp) { defer.resolve(resp); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Delete a company. The backend only unlinks the customers (sub-accounts),
  // it never deletes them.
  App.reqres.setHandler('company:delete', function (secId) {
    return $.ajax({
      type: 'DELETE',
      url: Settings.url('compuzz2', 'companies.json/' + secId)
    });
  });

  App.reqres.setHandler('company:orders-url', function (secId, params) {
    return Settings.url('compuzz2', 'companies.json/' + secId + '/orders', params);
  });

  App.reqres.setHandler('company:orders-count-url', function (secId) {
    return Settings.url('compuzz2', 'companies.json/' + secId + '/orders/rowCount');
  });

  App.reqres.setHandler('company:offers-url', function (secId, params) {
    return Settings.url('compuzz2', 'companies.json/' + secId + '/offers', params);
  });

  App.reqres.setHandler('company:offers-count-url', function (secId) {
    return Settings.url('compuzz2', 'companies.json/' + secId + '/offers/rowCount');
  });

  return {
    Company: Company,
    Companies: Companies
  };
});

